import { default as i18n } from 'i18next';
import { initReactI18next } from 'react-i18next';
import LngDetector from 'i18next-browser-languagedetector';
import translationDE from '@ivario-arc/shared/src/locales/de/translation';
import translationUS from '@ivario-arc/shared/src/locales/en/translation';
import translationNL from '@ivario-arc/shared/src/locales/nl/translation';
import { Locale } from '@ivario-arc/shared/src/types/locales';

declare module 'i18next' {
  interface CustomTypeOptions {
    returnNull: false;
  }
}

export const resources = {
  [Locale.DE]: translationDE,
  'en-US': translationUS,
  [Locale.EN]: translationUS,
  [Locale.NL]: translationNL,
  'nl-NL': translationNL,
} as const;

void i18n
  .use(LngDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    resources,
    returnNull: false,
    fallbackLng: Locale.DE,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  });

document.documentElement.lang = i18n.language;

export default i18n;
